import { render, staticRenderFns } from "./NotificationPage.vue?vue&type=template&id=13483321&scoped=true"
import script from "./NotificationPage.vue?vue&type=script&lang=ts"
export * from "./NotificationPage.vue?vue&type=script&lang=ts"
import style0 from "./NotificationPage.vue?vue&type=style&index=0&id=13483321&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13483321",
  null
  
)

export default component.exports